var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/types/route-group-item-waypoints.enum.ts
var route_group_item_waypoints_enum_exports = {};
__export(route_group_item_waypoints_enum_exports, {
  RouteGroupItemWaypointStatus: () => RouteGroupItemWaypointStatus,
  RouteGroupItemWaypointsSideloading: () => RouteGroupItemWaypointsSideloading
});
module.exports = __toCommonJS(route_group_item_waypoints_enum_exports);
var RouteGroupItemWaypointsSideloading = /* @__PURE__ */ ((RouteGroupItemWaypointsSideloading2) => {
  RouteGroupItemWaypointsSideloading2["RouteGroupItem"] = "routeGroupItem";
  RouteGroupItemWaypointsSideloading2["Object"] = "object";
  RouteGroupItemWaypointsSideloading2["ObjectOwner"] = "objectOwner";
  RouteGroupItemWaypointsSideloading2["ObjectItem"] = "objectItem";
  RouteGroupItemWaypointsSideloading2["ObjectItemDischarge"] = "objectItemDischarge";
  RouteGroupItemWaypointsSideloading2["WaypointLogDetails"] = "waypointLogDetails";
  RouteGroupItemWaypointsSideloading2["WaypointLogs"] = "waypointLogs";
  RouteGroupItemWaypointsSideloading2["Kojv"] = "kojv";
  RouteGroupItemWaypointsSideloading2["KojvService"] = "kojvService";
  RouteGroupItemWaypointsSideloading2["WaypointKojv"] = "waypointKojv";
  RouteGroupItemWaypointsSideloading2["WaypointContract"] = "waypointContract";
  RouteGroupItemWaypointsSideloading2["WaypointOwner"] = "waypointOwner";
  RouteGroupItemWaypointsSideloading2["WaypointUnload"] = "waypointUnload";
  RouteGroupItemWaypointsSideloading2["Owner"] = "owner";
  RouteGroupItemWaypointsSideloading2["ItemType"] = "itemType";
  RouteGroupItemWaypointsSideloading2["Garbage"] = "garbage";
  RouteGroupItemWaypointsSideloading2["Contract"] = "contract";
  RouteGroupItemWaypointsSideloading2["Village"] = "village";
  RouteGroupItemWaypointsSideloading2["City"] = "city";
  RouteGroupItemWaypointsSideloading2["County"] = "county";
  RouteGroupItemWaypointsSideloading2["Weight"] = "weight";
  RouteGroupItemWaypointsSideloading2["Price"] = "price";
  RouteGroupItemWaypointsSideloading2["ExtraServicePrice"] = "extraServicePrice";
  RouteGroupItemWaypointsSideloading2["ObjectAddress"] = "objectAddress";
  return RouteGroupItemWaypointsSideloading2;
})(RouteGroupItemWaypointsSideloading || {});
var RouteGroupItemWaypointStatus = /* @__PURE__ */ ((RouteGroupItemWaypointStatus2) => {
  RouteGroupItemWaypointStatus2["Done"] = "done";
  RouteGroupItemWaypointStatus2["Failed"] = "fail";
  return RouteGroupItemWaypointStatus2;
})(RouteGroupItemWaypointStatus || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RouteGroupItemWaypointStatus,
  RouteGroupItemWaypointsSideloading
});
